document.addEventListener('DOMContentLoaded', function () {

  const sticky = document.getElementById('BogoSticky');

  if (!sticky) return;

  const toggle = sticky.querySelector('[data-bogo-toggle]');
  const progress = sticky.querySelector('[data-bogo-progress]');
  const itemsContainer = sticky.querySelector('[data-bogo-items]');
  const checkoutButton = sticky.querySelector('[data-bogo-checkout]');
  const counter = sticky.querySelector('.bogo-sticky__price');

  const cartDrawer = document.querySelector('cart-drawer');

function syncBogoWithCartDrawer() {
  if (!cartDrawer) return;

  const cartIsOpen =
    cartDrawer.classList.contains('active') ||
    cartDrawer.hasAttribute('open');

  sticky.classList.toggle(
    'is-hidden-by-cart',
    cartIsOpen
  );
}

if (cartDrawer) {
  const cartDrawerObserver = new MutationObserver(
    syncBogoWithCartDrawer
  );

  cartDrawerObserver.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['class', 'open']
  });

  syncBogoWithCartDrawer();
}

  const ctaText = sticky.querySelector('[data-bogo-cta-text]');

  const STORAGE_KEY = 'bogoBundleV5';

  let bundle = [];

  /* ==============================
     LOAD SAVED BUNDLE
  ============================== */

  try {
    const savedBundle = JSON.parse(
      sessionStorage.getItem(STORAGE_KEY) || '[]'
    );

    if (Array.isArray(savedBundle)) {
      bundle = savedBundle.slice(0, 2);
    }
  } catch (error) {
    bundle = [];
  }


  /* ==============================
     HELPERS
  ============================== */

  function saveBundle() {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(bundle)
    );
  }


  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  function displaySize(value) {

    if (!value) return '';

    const parts = String(value).split(' x ');

    return parts.length > 1
      ? parts[parts.length - 1]
      : value;
  }

  function formatMoney(cents) {
  const currency =
    window.Shopify?.currency?.active || 'EUR';

  return new Intl.NumberFormat(
    document.documentElement.lang || 'es-ES',
    {
      style: 'currency',
      currency: currency
    }
  ).format(cents / 100);
}


  function getVariantsFromCard(card) {

  return Array.from(
    card.querySelectorAll('[data-bogo-variant]')
  ).map(variant => ({
    id: variant.dataset.variantId,
    title: variant.dataset.variantTitle,
    available: variant.dataset.available === 'true',
    priceCents: Number(variant.dataset.priceCents || 0),

    options: [
      variant.dataset.option1 || '',
      variant.dataset.option2 || '',
      variant.dataset.option3 || ''
    ]
  }));
}


  /* ==============================
     RENDER STICKY
  ============================== */

  function renderBundle() {

    const count = bundle.length;

    if (counter) {

  if (count === 2) {

    const selectedPrices = bundle.map(item => {

      const selectedVariant = item.variants.find(
        variant =>
          String(variant.id) === String(item.variantId)
      );

      return selectedVariant?.priceCents || 0;

    });

    const originalTotal = selectedPrices.reduce(
      (total, price) => total + price,
      0
    );

    const finalPrice = Math.max(...selectedPrices);

    counter.innerHTML = `
      <span class="bogo-sticky__original-price">
        ${formatMoney(originalTotal)}
      </span>

      <span class="bogo-sticky__final-price">
        ${formatMoney(finalPrice)}
      </span>
    `;

  } else {

    counter.textContent = `${count}/2`;

  }

}

    if (progress) {
      progress.style.width = `${count * 50}%`;
    }


    if (itemsContainer) {

      itemsContainer.innerHTML = bundle.map((item, index) => {

        const selectedVariant =
          item.variants.find(
            variant => String(variant.id) === String(item.variantId)
          ) || item.variants[0];

        let sizeButtons = '';

item.variants.forEach(variant => {

  let label = variant.title;

  if (item.sizeOptionIndex >= 0) {
    label = displaySize(
      variant.options[item.sizeOptionIndex]
    );
  }

  const isSelected =
    String(variant.id) === String(selectedVariant.id);

  sizeButtons += `
    <button
      type="button"
      class="bogo-sticky__size-option${isSelected ? ' is-selected' : ''}"
      data-bogo-sticky-size
      data-index="${index}"
      data-variant-id="${escapeHTML(variant.id)}"
      ${variant.available ? '' : 'disabled'}
    >
      ${escapeHTML(label)}
    </button>
  `;
});


        return `
          <div
            class="bogo-sticky__item"
            data-bogo-item
            data-index="${index}"
          >

            ${
              item.image
                ? `
                  <img
                    class="bogo-sticky__item-image"
                    src="${escapeHTML(item.image)}"
                    alt="${escapeHTML(item.title)}"
                  >
                `
                : ''
            }

            <div class="bogo-sticky__item-info">

              <div class="bogo-sticky__item-title">
                ${escapeHTML(item.title)}
              </div>

              <div class="bogo-sticky__size-block">

  <div class="bogo-sticky__size-options">
    ${sizeButtons}
  </div>

</div>

            </div>

            <button
              type="button"
              class="bogo-sticky__remove"
              data-bogo-remove
              data-index="${index}"
              aria-label="Remove product"
            >
              ×
            </button>

          </div>
        `;

      }).join('');
    }


    /* CTA */

    if (checkoutButton) {
      checkoutButton.disabled = count !== 2;
    }


    /* PRODUCT CARD BUTTONS */

    document.querySelectorAll('[data-bogo-add]').forEach(button => {

      const productId = button.dataset.productId;

      const added = bundle.some(
        item => String(item.productId) === String(productId)
      );

      button.classList.toggle('is-added', added);

      button.textContent = added
        ? 'ADDED'
        : 'ADD TO BUNDLE';

      button.setAttribute(
        'aria-pressed',
        added ? 'true' : 'false'
      );

    });

  }


  /* ==============================
     OPEN / CLOSE STICKY
  ============================== */

  if (toggle) {

    toggle.addEventListener('click', function () {
      sticky.classList.toggle('is-open');
    });

  }


  /* ==============================
   ADD BUNDLE TO SHOPIFY CART
============================== */

let isAddingToCart = false;

if (checkoutButton) {

  checkoutButton.addEventListener('click', async function (event) {

    event.preventDefault();
    event.stopPropagation();

    if (bundle.length !== 2 || isAddingToCart) {
      return;
    }

    const variantIds = bundle
      .map(item => Number(item.variantId))
      .filter(id => Number.isFinite(id));

    if (variantIds.length !== 2) {
      return;
    }

    isAddingToCart = true;
    checkoutButton.disabled = true;

    if (ctaText) {
      ctaText.textContent = 'ADDING...';
    }

    try {

  const root =
    window.Shopify?.routes?.root || '/';


  /* ==============================
     1. ADD BOTH PRODUCTS
  ============================== */

  const cartData = {
    items: variantIds.map(id => ({
      id: id,
      quantity: 1
    }))
  };


  const response = await fetch(
    `${root}cart/add.js`,
    {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      credentials: 'same-origin',

      body: JSON.stringify(cartData)
    }
  );


  const result = await response.json();


  if (!response.ok) {

    throw new Error(
      result.description ||
      result.message ||
      'Could not add bundle to cart'
    );

  }


  /* ==============================
     2. GET FRESH CART DRAWER HTML
  ============================== */

  const sectionsResponse = await fetch(
    `${root}?sections=cart-drawer,cart-icon-bubble&_=${Date.now()}`,
    {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',

      headers: {
        'Accept': 'application/json'
      }
    }
  );


  if (!sectionsResponse.ok) {
    throw new Error('Could not refresh cart drawer');
  }


  const freshSections =
    await sectionsResponse.json();


  /* ==============================
     3. RESET BOGO
  ============================== */

  bundle = [];

  sessionStorage.removeItem(STORAGE_KEY);

  renderBundle();

  sticky.classList.remove('is-open');


  /* ==============================
     4. RENDER FRESH CART DRAWER
  ============================== */

  if (
    cartDrawer &&
    typeof cartDrawer.renderContents === 'function'
  ) {

    cartDrawer.classList.remove('is-empty');

    const drawerInner =
      cartDrawer.querySelector('.drawer__inner');

    if (drawerInner) {
      drawerInner.classList.remove('is-empty');
    }


    cartDrawer.renderContents({
      id: variantIds[0],
      sections: freshSections
    });

  } else {

    window.location.href = `${root}cart`;

  }


    } catch (error) {

      console.error('BOGO cart error:', error);

      if (ctaText) {
        ctaText.textContent = 'TRY AGAIN';
      }

      setTimeout(() => {

        if (ctaText) {
          ctaText.textContent = 'ADD TO CART';
        }

        checkoutButton.disabled =
          bundle.length !== 2;

      }, 1500);

    } finally {

      isAddingToCart = false;

      if (bundle.length === 2) {
        checkoutButton.disabled = false;
      }

      if (
        ctaText &&
        ctaText.textContent === 'ADDING...'
      ) {
        ctaText.textContent = 'ADD TO CART';
      }

    }

  });

}

  /* ==============================
     ADD PRODUCT TO BUNDLE
  ============================== */

  document.addEventListener('click', function (event) {

    const addButton = event.target.closest('[data-bogo-add]');

    if (addButton) {

      event.preventDefault();
      event.stopPropagation();

      const card = addButton.closest('[data-bogo-card]');

      if (!card) return;


      const productId = card.dataset.productId;

      const alreadyAdded = bundle.some(
        item => String(item.productId) === String(productId)
      );


      /*
       * Product already selected:
       * just open sticky so customer can edit size.
       */

      if (alreadyAdded) {
        sticky.classList.add('is-open');
        return;
      }


      /*
       * Maximum 2 pieces.
       */

      if (bundle.length >= 2) {
        sticky.classList.add('is-open');
        return;
      }


      const allVariants = getVariantsFromCard(card);

      const defaultVariantId =
        card.dataset.defaultVariantId;

      const defaultVariant =
        allVariants.find(
          variant =>
            String(variant.id) === String(defaultVariantId)
        ) ||
        allVariants.find(variant => variant.available);


      if (!defaultVariant) return;


      const sizeOptionIndex =
        parseInt(card.dataset.sizeOptionIndex, 10);


      /*
       * Only keep variants that belong to the
       * same product configuration as the default
       * variant, changing only Size.
       */

      let selectableVariants = allVariants.filter(variant => {

        if (sizeOptionIndex < 0) return true;

        return variant.options.every((option, optionIndex) => {

          if (optionIndex === sizeOptionIndex) {
            return true;
          }

          return option === defaultVariant.options[optionIndex];

        });

      });


      if (!selectableVariants.length) {
        selectableVariants = [defaultVariant];
      }


      /*
       * Make sure selected variant is actually
       * inside the available size variants.
       */

      const selectedVariant =
        selectableVariants.find(
          variant =>
            String(variant.id) === String(defaultVariant.id)
        ) || selectableVariants[0];


      bundle.push({
        productId: productId,
        title: card.dataset.productTitle,
        image: card.dataset.productImage,
        sizeOptionIndex: sizeOptionIndex,
        variantId: selectedVariant.id,
        variants: selectableVariants
      });


      saveBundle();
      renderBundle();

      /*
       * Open footer automatically so customer
       * sees the size selector.
       */

      sticky.classList.add('is-open');

      return;
    }


    /* ==============================
   CHANGE SIZE IN STICKY
============================== */

const stickySizeButton =
  event.target.closest('[data-bogo-sticky-size]');

if (stickySizeButton) {

  event.preventDefault();
  event.stopPropagation();

  const index =
    parseInt(stickySizeButton.dataset.index, 10);

  if (
    Number.isNaN(index) ||
    !bundle[index]
  ) {
    return;
  }

  bundle[index].variantId =
    stickySizeButton.dataset.variantId;

  saveBundle();
  renderBundle();

  return;
}


    /* ==============================
       REMOVE PRODUCT
    ============================== */

    const removeButton =
      event.target.closest('[data-bogo-remove]');

    if (removeButton) {

      const index =
        parseInt(removeButton.dataset.index, 10);

      if (!Number.isNaN(index)) {

        bundle.splice(index, 1);

        saveBundle();
        renderBundle();

      }

    }

  });


  /* ==============================
     INITIAL RENDER
  ============================== */

  renderBundle();

});